import { Practitioner } from "fhir/r5";
import { loadAllResources, loadResource } from "./FhirBundleService";

const PRACTITIONER_SEARCH_PARAMS = {
  _count: "200",
  _elements:
    "id,name,identifier,active,gender,birthDate,telecom,qualification",
  _sort: "name",
};

async function loadPractitioner(
  practitionerId: string
): Promise<Practitioner> {
  return loadResource<Practitioner>("Practitioner", practitionerId ?? "");
}

async function loadAllPractitioners(): Promise<Practitioner[]> {
  return loadAllResources<Practitioner>(
    "Practitioner",
    PRACTITIONER_SEARCH_PARAMS
  );
}

const PractitionerService = {
  loadPractitioner,
  loadAllPractitioners,
};

export default PractitionerService;
